import { render, staticRenderFns } from "./manualSplit.vue?vue&type=template&id=316c934e&scoped=true&"
import script from "./manualSplit.vue?vue&type=script&lang=js&"
export * from "./manualSplit.vue?vue&type=script&lang=js&"
import style0 from "./manualSplit.vue?vue&type=style&index=0&id=316c934e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316c934e",
  null
  
)

export default component.exports